export default __webpack_public_path__ + "static/media/u_copy.7627226a.svg";